import { Index } from './src/Index';
import { RootSiblingParent } from 'react-native-root-siblings';

export default function App() {
  return (
    <RootSiblingParent> 
      <Index />
    </RootSiblingParent>
  );
}